module.exports = __webpack_public_path__ + "static/room--laundry.cf1b4511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/room--laundry.png
// module id = 36
// module chunks = 8482045208941 35783957827783 105603797122985 114276838955818 126609682503911 164485488089077 252234152318474